import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { startGardenSound } from "@/lib/gardenSound";

export default function SoundWelcome() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("garden-sound-choice")) return;
        const t = setTimeout(() => setVisible(true), 3000);
        return () => clearTimeout(t);
    }, []);

    const choose = (withSound) => {
        localStorage.setItem("garden-sound-choice", withSound ? "sound" : "silence");
        if (withSound) startGardenSound();
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ opacity: 0, y: 24, x: "-50%" }}
                    animate={{ opacity: 1, y: 0, x: "-50%" }}
                    exit={{ opacity: 0, y: 16, x: "-50%" }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-24 left-1/2 z-50 w-[92vw] max-w-sm rounded-sm border border-[rgba(212,175,55,0.4)] bg-[rgba(15,35,24,0.85)] p-6 text-center shadow-[0_20px_60px_rgba(0,0,0,0.6)] backdrop-blur-xl"
                    data-testid="sound-welcome-card"
                >
                    <p className="font-cinzel text-[0.6rem] tracking-[0.35em] text-[#b89860] uppercase">
                        Before You Wander Further
                    </p>
                    <p className="font-cormorant mt-3 text-lg italic leading-relaxed text-[#e8dcc0]">
                        The garden has a voice — a running river, and birdsong.
                        Would you like to enter with sound?
                    </p>
                    <div className="mt-5 flex justify-center gap-3">
                        <button
                            onClick={() => choose(true)}
                            data-testid="sound-welcome-yes"
                            className="btn-eden rounded-sm bg-gradient-to-br from-[rgba(160,120,60,0.9)] to-[rgba(120,85,40,0.9)] px-6 py-3 text-[0.65rem] text-[#f5e6c8]"
                        >
                            With Sound
                        </button>
                        <button
                            onClick={() => choose(false)}
                            data-testid="sound-welcome-no"
                            className="btn-eden rounded-sm bg-transparent px-6 py-3 text-[0.65rem] text-[#d4af37]"
                        >
                            In Silence
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
